<template>
  <div>
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="120"
      class="search-list-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="课程类别">
          <Cascader
            v-model="typeList"
            :disabled="
              (!schoolId && portOrg != 2) ||
                schoolId == -1
            "
            :placeholder="
              (!schoolId && portOrg != 2) ||
                schoolId == -1
                ? '请选择学校'
                : '请选择'
            "
            :data="classTypeCascaderList"
            :load-data="loadTypeData"
          ></Cascader>
        </FormItem>
        <FormItem label="退款的上课日期">
          <DatePicker
            type="daterange"
            transfer
            placeholder="请选择日期"
            style="width: 300px"
            @on-change="handleDateChange"
          ></DatePicker>
          <!-- <DatePicker
            type="date"
            multiple
            placeholder="请选择日期"
            style="width: 300px"
            @on-change="handleDateChange"
          ></DatePicker> -->
        </FormItem>
        <FormItem label="课程类型">
          <Select
            v-model="searchConds.offerOrgType"
            placeholder="请选择课程类型"
            clearable
            style="width: 300px"
          >
            <Option value="1">校内课程</Option>
            <Option value="2">校外课程</Option>
          </Select>
        </FormItem>
        <Button type="primary" @click="handleSearch">查询</Button>
      </Row>
    </Form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import courseCenterApi from '@/request/courseCenter/courseCenterApi.js';
import { courseTypeData } from '../../assets/data/BatchRefund';
import { quelityTypeList, hostingTypeList } from '@/utils/dictionary';
import { getAllDate } from '@utils/utils';
export default {
  props: {
    schoolId: {
      type: String || Number,
      default: ''
    }
  },
  data() {
    return {
      courseTypeData: courseTypeData,
      portOrg: Number(localStorage.getItem('portOrg')),
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      loadingSchool: false,
      searchConds: {
        schoolId: '',
        yearCode: '',
        termCode: '',
        // classType: '',
        // courseTypeId: '',
        // courseTypeKind: '',
        date: '',
        offerOrgType: null
      },
      schoolIdList: [], // 学校
      termIdList: [], // 学期
      courseTypeL: [],
      courseTypeDataUse: JSON.parse(JSON.stringify(courseTypeData)),
      loading: false,
      typeList: [],
      quelityTypeList: [...quelityTypeList].slice(1, quelityTypeList.length), // 课程类型-素质
      hostingTypeList: [...hostingTypeList].slice(1, hostingTypeList.length), // 课程类型-基础托管
      courseTypeListAnother: [], // 课程分类
      classTypeCascaderList: [
        {
          value: 1,
          label: '素质课程'
        },
        {
          value: '2',
          label: '托管',
          children: [],
          loading: false
        }
      ],
      classTypeList: [{
        id: 1,
        value: '素质课程'
      }, {
        id: 2,
        value: '托管'
      }]
    };
  },
  computed: {
    ...mapGetters(['theUserIdentity'])
  },
  methods: {
    async loadTypeData(item, callback) {
      if (item.label === '素质课程' && item.value === 1) {
        this.searchConds.classType = item.value;
        callback();
      } else if (item.label === '托管') {
        item.loading = true;
        await this.getTapList(item.value);
        item.loading = false;
        if (this.loading) {
          delete item.loading;
        }
        callback();
      } else {
        item.loading = true;
        // this.courseTypeKind = item.value;
        // 获取三级
        await this.getCourseType(item.value);
        item.children = this.courseTypeListAnother;
        item.loading = false;
        callback();
      }
    },
    // 课程分类二级列表
    async getTapList(type) {
      const params = {
        orgId: this.schoolId,
        courseTypeAttr: type
      };
      const res = await courseCenterApi.getTapList(params);
      // console.log('res', res);
      if (res.status === 200) {
        if (res.message.length) {
          if (+type === 1) {
            const quelityTypeList = [];
            this.quelityTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  quelityTypeList.push(ele);
                }
              });
            });
            quelityTypeList.forEach((ele) => {
              ele.children = [];
              ele.loading = false;
            });
            this.classTypeCascaderList.length > 0
              ? (this.classTypeCascaderList[0].children = quelityTypeList)
              : '';
          } else {
            const hostingTypeList = [];
            this.hostingTypeList.forEach((ele) => {
              res.message.forEach((item) => {
                if (ele.value == item) {
                  hostingTypeList.push(ele);
                }
              });
            });
            hostingTypeList.forEach((ele) => {
              ele.children = [];
              ele.loading = false;
            });
            this.classTypeCascaderList[1].children = hostingTypeList;
          }
        } else {
          this.loading = true;
        }
      }
    },
    // 课程分类三级列表
    async getCourseType(courseTypeKind) {
      let params = {};
      switch (this.theUserIdentity) {
        // 当是机构端的时候 - orgId 传学校ID或者教育局ID
        case 'org':
          params = {
            orgId: this.schoolId,
            courseTypeKind
          };
          break;
        default:
          params = {
            orgId: this.schoolId,
            courseTypeKind
          };
          break;
      }
      const res = await courseCenterApi.getCourseTypeTapList(params);
      if (res.status === 200) {
        if (res.message.length) {
          res.message.forEach((ele) => {
            ele.value = ele.courseTypeId;
            ele.label = ele.courseTypeName;
          });
          this.courseTypeListAnother = res.message;
        } else {
          this.courseTypeListAnother = [];
        }
      }
    },
    handleSearch() {
      this.$emit('on-search', this.searchConds, this.typeList);
    },
    // 自定义级联显示内容
    format(labels, selectedData) {
      return labels.join('-');
    },
    // 上课日期
    handleDateChange(date) {
      const dayMap = getAllDate(date[0], date[1]);
      console.log(dayMap, '所有日期----');
      const dateStr = dayMap.join();
      console.log(dateStr, '是啥---');
      this.searchConds.date = dateStr;
    }
    // handleDateChange(date) {
    //   console.log(date, '上课日期====');
    //   this.searchConds.date = date;
    // }
  }
};
</script>

<style>
</style>
